// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {type AppBskyUnspeccedGetPostThreadV2} from '@atproto/api'

/**
 * See the `below` param on {@link AppBskyUnspeccedGetPostThreadV2.QueryParams}
 */
export const LINEAR_VIEW_BELOW = 10

/**
 * See the `branchingFactor` param on {@link AppBskyUnspeccedGetPostThreadV2.QueryParams}
 */
export const LINEAR_VIEW_BF = 1

/**
 * See the `below` param on {@link AppBskyUnspeccedGetPostThreadV2.QueryParams}
 */
export const TREE_VIEW_BELOW = 4

/**
 * See the `branchingFactor` param on {@link AppBskyUnspeccedGetPostThreadV2.QueryParams}
 */
export const TREE_VIEW_BF = undefined

/**
 * See the `below` param on {@link AppBskyUnspeccedGetPostThreadV2.QueryParams}
 */
export const TREE_VIEW_BELOW_DESKTOP = 6
